// extracted by mini-css-extract-plugin
module.exports = {"m":"_32jO4jnL3n_calculator","l":"lO2X6Ywo_-_calculator"};